module.exports = __webpack_public_path__ + "img/1409526269.e9f78f07.jpg";